import React, { useCallback, useState } from "react";

import ShipeeziGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { RoomJob } from "Models/sales";
import { useTranslation } from "react-i18next";
import getAllMaterialsFromRoom from "Util/getAllMaterialsFromRoom";

import { RoomJobCustomerPortal } from "../../../../../../../models/customer.portal";
import { AfterRoomRow } from "../AfterRoomRow";
import { EmptyState } from "../EmptyState";
import { EstimatedRoomMobile } from "../EstimatedRoomMobile";
import { RoomRow } from "../RoomRow";
import { LoadingWrapper, LoadingSpinner, GridContainer, RoomsContentMobile } from "./styles";

interface EstimatedInventoryProps {
  inventory: RoomJobCustomerPortal[];
  isLoading?: boolean;
}

const EstimatedInventory = ({ inventory, isLoading }: EstimatedInventoryProps) => {
  const [collapseds, setCollapseds] = useState<string[]>([]);

  const { t: translate } = useTranslation();

  const renderAfterRow = (data?: RoomJobCustomerPortal) => {
    const room = data?.name;

    if (!room || !collapseds.find((item) => item === room)) return null;

    return (
      <AfterRoomRow roomItemsJobs={data?.itemsJob || []} roomMaterials={data?.materials || []} />
    );
  };

  const toggleCollapse = useCallback((room?: string) => {
    if (room) {
      setCollapseds((prev) => {
        if (prev.find((item) => item === room)) {
          return prev.filter((item) => item !== room);
        }

        return [...prev, room];
      });
    }
  }, []);

  const columns: Column[] = [
    {
      name: "name",
      title: translate("rooms"),
      hideSort: true,
      formatComponent: (roomName?: string, room?: RoomJobCustomerPortal) => (
        <RoomRow
          collapseds={collapseds}
          toggleCollapse={toggleCollapse}
          room={room}
          roomName={roomName}
        />
      ),
    },
  ];

  if (isLoading) {
    return (
      <LoadingWrapper>
        <LoadingSpinner size={48} disableShrink />
      </LoadingWrapper>
    );
  }

  return (
    <>
      {inventory.length ? (
        <>
          <GridContainer>
            <ShipeeziGrid
              data={inventory}
              columns={columns}
              renderAfterRow={renderAfterRow}
              showSelection={false}
              showColumnChooser={false}
            />
          </GridContainer>
          <RoomsContentMobile>
            {inventory?.map((room: RoomJobCustomerPortal, index: number) => {
              return (
                <EstimatedRoomMobile
                  room={room}
                  key={index}
                  items={room?.itemsJob || []}
                  materials={getAllMaterialsFromRoom(room as RoomJob)}
                  roomName={room?.name || ""}
                />
              );
            })}
          </RoomsContentMobile>
        </>
      ) : (
        <EmptyState
          title={translate("allItemsPacked")}
          description={translate("allYourItemsHaveBeenPackedAndEverythingIsFine")}
        />
      )}
    </>
  );
};

export default EstimatedInventory;
